import { render, staticRenderFns } from "./productDetail.vue?vue&type=template&id=52334e9a"
import script from "./productDetail.vue?vue&type=script&lang=js"
export * from "./productDetail.vue?vue&type=script&lang=js"
import style0 from "./productDetail.vue?vue&type=style&index=0&id=52334e9a&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52334e9a')) {
      api.createRecord('52334e9a', component.options)
    } else {
      api.reload('52334e9a', component.options)
    }
    module.hot.accept("./productDetail.vue?vue&type=template&id=52334e9a", function () {
      api.rerender('52334e9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/productmanager/productDetail.vue"
export default component.exports